import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {isNullOrUndefined} from 'util';

import {DictModel} from '../../../dictionary/dict.model';
import {DictService} from '@core/ecv-http-services/services/dict.service';
import {EcvLanguageService} from '@core/ecv-language.service';
import {DictEnum} from '../../../enums/dict.enum';


@Component({
  selector: 'app-label-list',
  templateUrl: './label-list.component.html'
})
export class LabelListComponent implements OnChanges, OnInit {
  @ViewChild('input') input: ElementRef;
  @Input() data: number;
  @Input() dictData: DictModel;
  @Input() inputName: string;
  @Input() inputLabel: string;
  @Input() formGroup: FormGroup;
  @Input() maxLength: number;
  @Input() formIndex: number;
  @Output() dataChange = new EventEmitter<any>();
  @Output() dictDataChange = new EventEmitter<any>();
  @Output() enterPressed = new EventEmitter();
  @Input() dictType: DictEnum;

  dictionary: DictModel[] = [];
  itemDescription: string;
  inputFocused = false;
  listFocused: boolean[] = [];
  correctData = true;
  maxItemsAmount = 30;
  currentDict: DictModel;
  requestNumber = 0;

  constructor(private dictService: DictService, private languageService: EcvLanguageService) {
    this.maxLength = 50;
  }

  ngOnInit() {
    this.onDictIdChanged();
    this.languageService.getLanguage$().subscribe(
      res => this.switchLanguage());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.onDictIdChanged();
    }
  }

  private switchLanguage() {
    if (this.currentDict && this.data && this.itemDescription) {
      this.itemDescription = this.dictDescription(this.currentDict);
    }
  }

  /**
   * Called when dictId changed because of directive data binding.
   * It sets itemDescription properly.
   */
  private onDictIdChanged() {
    if (!this.data) {
      if (this.data === undefined) {
        this.itemDescription = '';
      }
      this.updateAutocompleteList();
      this.currentDict = null;
      return;
    }

    this.dictService.getDictionary(this.data).subscribe(
      res => {
        this.itemDescription = this.dictDescription(<DictModel>res);
        this.currentDict = <DictModel>res;
      }
    );
  }

  /**
   * Called when one of autocomplete element has been chosen.
   * It delegates setting new chosen dictionary,
   * clears appropriate focus flag and
   * delegates updating autocomplete list appropriately.
   */
  onDictChosenFromAutocompleteList(dict: DictModel, index?: number) {
    this.setChosenDict(dict);

    // release autocomplete focus
    if (!isNullOrUndefined(index)) {
      this.listFocused[index] = false;
    }

    this.updateAutocompleteList();
  }

  private onDescriptionInputChanged() {
    this.correctData = false;
    this.clearChosenDict();
    this.updateAutocompleteList();
  }

  private updateAutocompleteList() {
    if (!this.itemDescription || !this.itemDescription.trim()) {
      this.correctData = true;
      return this.dictionary = [];
    }

    const searchedPhrase = this.itemDescription.toLowerCase().trim();
    this.requestNumber = this.requestNumber + 1;
    const lastRequestNumber = this.requestNumber;
    this.dictService.getDictContaining(this.dictType, this.languageService.getLanguage(), searchedPhrase).subscribe(
      response => {
        if (lastRequestNumber !== this.requestNumber) {
          return;
        }
        this.dictionary = <DictModel[]>response
          .slice(0, this.maxItemsAmount);
        if (this.dictionary.length === 0) {
          this.formGroup.get(this.inputName + '-id').markAsTouched({onlySelf: true});
        }
      });
  }

  setChosenDict(dict: DictModel) {
    this.setData(dict);

    // set description
    this.itemDescription = this.dictDescription(dict);
  }

  clearChosenDict() {
    this.setData(null);
  }

  setData(newData: DictModel) {
    const prevDataId = this.data;
    const newDataId = newData ? newData.id : null;

    this.data = newData ? newData.id : null;
    this.dictData = newData;
    this.correctData = (!!newData);

    if (prevDataId !== newDataId) {
      this.dataChanged();
    }
  }

  dataChanged() {
    this.dataChange.emit(this.data);
    this.dictDataChange.emit(this.dictData);
  }

  dictDescription(dict: DictModel): string {
    return this.languageService.pickFromDictionary(dict);
  }

  onKey(event) {
    this.onDescriptionInputChanged();
    if (event.keyCode === 13) {
      this.enterPressed.emit();
    }
  }

  focus() {
    this.input.nativeElement.focus();
  }

  getIsListFocused() {
    return this.listFocused.filter(x => x).length > 0;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/form-section/label-list/label-list.component.ts